import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Trash2 } from 'lucide-react';

export const CategorySettingsDialog = ({ open, onOpenChange, categories, newCategory, setNewCategory, onAdd, onDelete }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Manage Proposal Categories</DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <div className="flex gap-2">
          <Input
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            placeholder="New category name"
            onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), onAdd())}
          />
          <Button onClick={onAdd}>Add</Button>
        </div>
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {categories.length === 0 ? (
            <p className="text-sm text-muted-foreground text-center py-4">No categories yet. Add your first category above.</p>
          ) : (
            categories.map((cat) => (
              <div key={cat} className="flex items-center justify-between p-2 bg-muted rounded">
                <span>{cat}</span>
                <Button size="sm" variant="ghost" onClick={() => onDelete(cat)}>
                  <Trash2 className="h-4 w-4 text-destructive" />
                </Button>
              </div>
            ))
          )}
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
